import { WorkflowFilters } from '../../contexts/WorkflowContext';
import { Workflow, SortConfig } from './types';

// Filter function
export const filterWorkflows = (
  workflows: Workflow[],
  filters: WorkflowFilters
): Workflow[] => {
  if (!filters) return workflows;

  return workflows.filter((workflow) => {
    // Filter by account ID
    if (
      filters.accountId &&
      !workflow.accountId
        ?.toLowerCase()
        .includes(filters.accountId.trim().toLowerCase())
    ) {
      return false;
    }

    // Filter by assigned to (Name or Email)
    if (filters.assignedTo) {
      const searchTerm = filters.assignedTo.trim().toLowerCase();
      const matchesName = workflow.assignedToName
        ?.toLowerCase()
        .includes(searchTerm);
      const matchesEmail = workflow.assignedTo
        ?.toLowerCase()
        .includes(searchTerm);

      if (!matchesName && !matchesEmail) {
        return false;
      }
    }

    // Filter by type
    if (filters.type && workflow.requestType !== filters.type.trim()) {
      return false;
    }

    return true;
  });
};

// Sort function
export const sortWorkflows = (
  workflows: Workflow[],
  sortConfig: SortConfig | null,
  table: 'my' | 'company'
): Workflow[] => {
  if (!sortConfig || sortConfig.table !== table) return workflows;

  return [...workflows].sort((a, b) => {
    const aValue = a[sortConfig.key];
    const bValue = b[sortConfig.key];

    // Handle undefined values
    if (aValue === undefined && bValue === undefined) return 0;
    if (aValue === undefined) return 1;
    if (bValue === undefined) return -1;

    if (aValue < bValue) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (aValue > bValue) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });
};

// Get processed workflows (filtered and sorted)
export const getProcessedWorkflows = (
  workflows: Workflow[],
  filters: WorkflowFilters,
  sortConfig: SortConfig | null,
  table: 'my' | 'company'
): Workflow[] => {
  const filtered = filterWorkflows(workflows, filters);
  return sortWorkflows(filtered, sortConfig, table);
};
